const timeZoneList = [
	{ countryCode: 'DEU', timeZone: 'Europe/Berlin' },
	{ countryCode: 'CHE', timeZone: 'Europe/Zurich' },
	{ countryCode: 'AUT', timeZone: 'Europe/Vienna' },
	{ countryCode: 'GBR', timeZone: 'Europe/London' },
]

export const getTimeZoneByCountryCode = (countryCode) => {
	return timeZoneList.find(item => item.countryCode === countryCode)?.timeZone
		|| timeZoneList[0].timeZone
}
